import Api from '@/services/Api'

export default {
  getList () {
    return Api().get('/webhotel/')
  },

  get (servername) {
    return Api().get('/webhotel/' + servername)
  },

  updatePassword (servername, password) {
    return Api().patch('/webhotel/' + servername, {password: password})
  },

  updatePasswordProtected (servername, passwordProtected) {
    return Api().patch('/webhotel/' + servername, {passwordProtected: passwordProtected})
  }
}
